import styled from 'styled-components'

import TextInput from '@/components/DEPRECATED_UI/TextInput'
import ToggleSwitch from '@/components/DEPRECATED_UI/ToggleSwitch'
import {
  Select,
  ItemHeader,
  InputGroup,
  CentredItemHeader,
} from '@/components/Style/Common'
import DateStringInput from '@/components/TextInput'
import type { EmploymentIncome } from '@/types/AddIncome'

import AddressInput from './AddressInput'
import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import IncomePropertiesInput from './IncomePropertiesInput'

const DateField = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px 5px;
`

export const CONTRACT_OPTIONS = [
  { label: 'Permanent', value: 'permanent' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Fixed-term', value: 'fixed-term' },
]

export const CONTRACT_SCHEDULE_OPTIONS = [
  { label: 'Full-Time', value: 'full-time' },
  { label: 'Part-Time', value: 'part-time' },
]

export const BONUS_FREQUENCY_OPTIONS = [
  { label: 'Annually', value: 'Annually' },
  { label: 'Quarterly', value: 'Quarterly' },
]

interface Props {
  income: EmploymentIncome
  propertyDispatch: PropertyDispatch
}

const EmployedIncomeInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  return (
    <div>
      {
        <div>
          <ItemHeader>Contract Type</ItemHeader>
          <Select
            value={income.contractType}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              propertyDispatch.set(Property.ContractType, e.target.value)
            }}
          >
            {CONTRACT_OPTIONS.map(({ label, value }, i) => (
              <option key={i} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </div>
      }
      {
        // eslint-disable-next-line eqeqeq
        income.contractType == 'permanent' && (
          <div>
            <ItemHeader>Start Date</ItemHeader>
            <DateField>
              <DateStringInput
                name="startDate"
                type="date"
                onChange={value => propertyDispatch.set(Property.StartDate, value)}
                value={income.startDate}
                placeholder="dd/mm/yyyy"
              />
            </DateField>
          </div>
        )
      }
      {
        // eslint-disable-next-line eqeqeq
        income.contractType != 'permanent' && (
          <div>
            <ItemHeader>Contract Start & End Date</ItemHeader>
            <InputGroup>
              <DateField>
                <DateStringInput
                  name="startDate"
                  type="date"
                  onChange={value => propertyDispatch.set(Property.StartDate, value)}
                  value={income.startDate}
                  placeholder="dd/mm/yyyy"
                />

                <DateStringInput
                  name="endDate"
                  type="date"
                  onChange={value => propertyDispatch.set(Property.EndDate, value)}
                  value={income.endDate}
                  placeholder="dd/mm/yyyy"
                />
              </DateField>
            </InputGroup>
          </div>
        )
      }
      <div>
        <ItemHeader>Employment Basis</ItemHeader>
        <Select
          value={income.contractSchedule}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            propertyDispatch.set(Property.ContractSchedule, e.target.value)
          }}
        >
          {CONTRACT_SCHEDULE_OPTIONS.map(({ label, value }, i) => (
            <option key={i} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </div>
      <IncomePropertiesInput
        incomeProperties={income.incomeProperties}
        propertyDispatch={propertyDispatch}
        amountProperty={Property.IncomeAmount}
        frequencyProperty={Property.IncomeFrequency}
        hourlyProperty={Property.IncomeHoursPerWeek}
      />
      <div>
        <div className="side-by-side-flex-start">
          <CentredItemHeader>Guaranteed bonus</CentredItemHeader>
          <ToggleSwitch
            initVal={income.hasGuaranteedBonus}
            toggle={() => {
              propertyDispatch.set(
                Property.HasGuaranteedBonus,
                !income.hasGuaranteedBonus,
              )
            }}
          />
        </div>
        {
          // eslint-disable-next-line eqeqeq
          income.hasGuaranteedBonus == true && (
            <div>
              <InputGroup>
                <TextInput
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    propertyDispatch.set(Property.BonusAmount, +e.target.value)
                  }}
                  value={income.bonus.value}
                  label="Bonus Value (£)"
                />
                <Select
                  value={income.bonus.frequency}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    propertyDispatch.set(Property.BonusFrequency, e.target.value)
                  }}
                >
                  {BONUS_FREQUENCY_OPTIONS.map(({ label, value }, i) => (
                    <option key={i} value={value}>
                      {label}
                    </option>
                  ))}
                </Select>
              </InputGroup>
            </div>
          )
        }
      </div>
      <div>
        <ItemHeader>Position</ItemHeader>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            propertyDispatch.set(Property.Position, e.target.value)
          }}
          value={income.position}
          label="Position"
        />
      </div>
      <div>
        <ItemHeader>Company Details</ItemHeader>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            propertyDispatch.set(Property.Company, e.target.value)
          }}
          value={income.company}
          label="Company Name"
        />
        <AddressInput address={income.address} propertyDispatch={propertyDispatch} />
      </div>
    </div>
  )
}

export default EmployedIncomeInput
